export default __webpack_public_path__ + "static/media/UglyBeauty60s.73741409.mp3";